import $ from 'jquery';
import Masonry from 'masonry-layout';

const masonryReviews = () => {
	const el = {
		target: '.cr-all-reviews-shortcode .commentlist',
		item: '.review',
		pagination: '.cr-all-reviews-shortcode .cr-all-reviews-pagination',
		loading: 'cr-pagination-load',
		summaryBox: '.ivole-summaryBox',
		summaryUpdating: 'cr-summaryBar-updating',
		description: '.review .description',
	};

	const cfg = {
		lines: 6, // collapse to this many lines
		lineHeight: 1.43, // in em, matches the description line-height
		clampedClass: 'cr-desc-clamped',
		expandedClass: 'cr-desc-expanded',
		buttonClass: 'cr-read-more',
		labels: { more: 'Lees meer', less: 'Minder lezen' },
	};

	const init = () => {
		$(function () {
			const container = document.querySelector(el.target);
			if (!container) return;
			exec(container);
		});
	};

	const exec = (container) => {
		const msnry = new Masonry(container, {
			itemSelector: el.item,
			columnWidth: el.item, // measure column from the first .review
			percentPosition: true, // position by % so it stays responsive
			transitionDuration: 0, // snap items, don't slide them across columns
			initLayout: false, // clamp descriptions first, then lay out once
		});

		setupReadMore(container, () => msnry.layout());
		msnry.layout();
		watchPagination(container, msnry);
	};

	// --- Read more -----------------------------------------------------------
	// Collapses any `.description` taller than
	//   padding-top + padding-bottom + (lines * lineHeight em)
	// and adds a toggle button. Each toggle re-lays out masonry via `onToggle`.
	const setupReadMore = (scope, onToggle) => {
		scope.querySelectorAll(el.description).forEach((desc) => {
			if (desc.dataset.crReadMore) return; // already processed

			const style = getComputedStyle(desc);
			const fontSize = parseFloat(style.fontSize) || 16;
			const padding =
				parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
			const maxHeight = padding + cfg.lines * cfg.lineHeight * fontSize;

			// `scrollHeight` returns the full content height regardless of the
			// max-height we set later. Safari note below.
			if (measureHeight(desc) <= maxHeight + 1) {
				desc.dataset.crReadMore = 'fit';
				return;
			}

			desc.dataset.crReadMore = 'clamped';
			desc.classList.add(cfg.clampedClass);
			desc.style.maxHeight = `${maxHeight}px`;

			const btn = document.createElement('button');
			btn.type = 'button';
			btn.className = cfg.buttonClass;
			btn.textContent = cfg.labels.more;
			desc.insertAdjacentElement('afterend', btn);

			btn.addEventListener('click', () => {
				const expanded = desc.classList.toggle(cfg.expandedClass);
				desc.style.maxHeight = expanded
					? `${measureHeight(desc)}px`
					: `${maxHeight}px`;
				btn.textContent = expanded ? cfg.labels.less : cfg.labels.more;
				if (typeof onToggle === 'function') onToggle();
			});
		});
	};

	// Safari compatibility: when `.description` wraps its text in <p> children,
	// `-webkit-line-clamp` does not work (it only clamps inline text directly in
	// the box), and collapsing <p> margins can throw off `scrollHeight`. We avoid
	// line-clamp entirely (using max-height), and measure the real content height
	// from the first child's top to the last child's bottom so margins are
	// counted consistently across browsers.
	const measureHeight = (desc) => {
		const kids = desc.children;
		if (!kids.length) return desc.scrollHeight;

		const first = kids[0].getBoundingClientRect();
		const last = kids[kids.length - 1].getBoundingClientRect();
		const padding =
			parseFloat(getComputedStyle(desc).paddingTop) +
			parseFloat(getComputedStyle(desc).paddingBottom);
		return Math.max(desc.scrollHeight, last.bottom - first.top + padding);
	};

	// Re-layout after the plugin finishes an AJAX pagination load.
	const watchPagination = (container, msnry) => {
		const relayout = () => {
			msnry.reloadItems();
			setupReadMore(container, () => msnry.layout()); // process new reviews
			msnry.layout();
		};

		// Re-layout on the falling edge of `busyClass` (present while an async
		// update runs, removed when it finishes).
		const observe = (node, busyClass) => {
			if (!node) return;
			let wasBusy = node.classList.contains(busyClass);

			const observer = new MutationObserver(() => {
				const isBusy = node.classList.contains(busyClass);
				if (wasBusy && !isBusy) {
					relayout();
				}
				wasBusy = isBusy;
			});

			observer.observe(node, {
				attributes: true,
				attributeFilter: ['class'],
			});
		};

		observe(container, el.loading);
		observe(document.querySelector(el.pagination), el.loading);
		observe(document.querySelector(el.summaryBox), el.summaryUpdating);
	};

	init();
};

try {
	masonryReviews();
} catch (error) {
	console.error(error);
}
